import {useState} from 'react';
import PropTypes from 'prop-types';

export default function RegisterScreen({onLogin}) {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [confirm, setConfirm] = useState('');
    const [error, setError] = useState('');

    async function handleSubmit(e) {
        e.preventDefault();
        setError('');
        if (password !== confirm) {
            setError('Passwords do not match');
            return;
        }
        try {
            const res = await fetch('/auth/register', {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({username, password}),
            });
            if (res.status === 403) {
                setError('Registration is not allowed for this username');
                return;
            }
            if (res.status === 409) {
                setError('Username is already taken');
                return;
            }
            if (!res.ok) {
                setError('Registration failed. Please try again.');
                return;
            }
            // Auto-login after successful registration
            const loginRes = await fetch('/auth/login', {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({username, password}),
            });
            if (!loginRes.ok) {
                // Registration succeeded but login failed; redirect to login screen
                window.location.replace('/?signin');
                return;
            }
            const data = await loginRes.json();
            onLogin(data.token, data.username, data.userID);
        } catch {
            setError('Registration failed. Please try again.');
        }
    }

    return (
        <div className="login-screen">
            <form className="register-form login-form" onSubmit={handleSubmit}>
                <h2 className="login-title">Create account</h2>
                {error ? <p className="login-error">{error}</p> : null}
                <input
                    className="login-input"
                    type="text"
                    placeholder="Username"
                    value={username}
                    onChange={e => setUsername(e.target.value)}
                    autoFocus
                />
                <input
                    className="login-input"
                    type="password"
                    placeholder="Password"
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                />
                <input
                    className="login-input"
                    type="password"
                    placeholder="Confirm password"
                    value={confirm}
                    onChange={e => setConfirm(e.target.value)}
                />
                <button
                    className="login-button"
                    type="submit"
                    disabled={!username || !password || !confirm}
                >Create account</button>
                <p className="login-register-link">
                    Already have an account? <a href="/?signin">Sign in</a>
                </p>
            </form>
        </div>
    );
}

RegisterScreen.propTypes = {
    onLogin: PropTypes.func.isRequired,
};
